// Must be first import to suppress third-party warnings
import './suppress-warnings'

import './scss/main.scss'

import { createApp } from 'vue'
import App from './App.vue'
import i18n from './i18n'
import { createVuestic } from 'vuestic-ui'
import { createGtm } from '@gtm-support/vue-gtm'

import stores from './stores'
import router from './router'
import vuesticGlobalConfig from './services/vuestic-ui/global-config'
import { useAuthStore } from './stores/auth-store'
import { useOUStore } from './stores/ou-store'
import permissionDirectives from './directives/permission'

// AG Grid imports
import '@/helpers/ag-grid-enterprise'
import '@/helpers/ag-grid-enterprise/styles/ag-grid.css'
import '@/helpers/ag-grid-enterprise/styles/ag-theme-alpine.css'
import { AgGridVue } from 'ag-grid-vue3'

const app = createApp(App)

// Filter out harmless vuestic-devtools warnings
app.config.warnHandler = (msg, _instance, _trace) => {
  // Suppress vuestic-devtools onMounted warning (harmless, from third-party)
  if (msg.includes('onMounted is called when there is no active component instance')) {
    return
  }
  // Log other warnings normally
  console.warn(`[Vue warn]: ${msg}`)
}

app.use(stores)
app.use(router)
app.use(i18n)
app.use(createVuestic({ config: vuesticGlobalConfig }))
app.use(permissionDirectives)
app.component('AgGridVue', AgGridVue)

if (import.meta.env.VITE_APP_GTM_ENABLED) {
  app.use(
    createGtm({
      id: import.meta.env.VITE_APP_GTM_KEY,
      debug: false,
      vueRouter: router,
    }),
  )
}

// Mount app first, then initialize stores
app.mount('#app')

// Initialize stores after mounting to avoid lifecycle warnings
const authStore = useAuthStore()
authStore.initializeAuth()

if (authStore.isAuthenticated) {
  const ouStore = useOUStore()
  ouStore.initialize()
}
